import Damage from "../../../../model/crew/Damage";
import BigNum from "../../../../model/math/BigNum";
import NumberFormatter from "../../../../util/NumberFormatter";
import Page from "../../../framework/Page";
import View from "../../../framework/View";

export default class GoldDamageView extends View {
    /**
     * @param {string} parentId
     * @param {Damage} damage
     */
    constructor(parentId, damage) {
        super(parentId, parentId + '_gold');

        /**
         * @constant
         * @type {Damage}
         */
        this.damage = damage;

        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedGoldDamageMultiplier = new BigNum(-1);
        /**
         * @type {string}
         */
        this.goldBonusString = null;

        /**
         * @type {HTMLElement}
         */
        this.body = null;

        this.setInitialVisibility(true);
    }

    /**
     * @override
     */
    initializeView() {
  
        const parentElement = Page.getElement(this.parentId);

        ////////////////////////////////////
        // gold
        ////////////////////////////////////

        const container = Page.createElement('div', parentElement, this.getElementId(), 'mine-damage-panel-main-section');
        
        const header = Page.createElement('div', container, null, 'mine-damage-panel-section-header');
        header.innerHTML = 'Gold';

        this.body = Page.createElement('div', container, null, 'mine-damage-panel-section-body');

        super.initializeView();        
    }

    /**
     * @override
     */
    updateViewContents() {

        const goldDamageMultiplier = this.damage.goldDamageMultiplier;

        if (!this.goldBonusString || !goldDamageMultiplier.equals(this.displayedGoldDamageMultiplier)) {
            this.displayedGoldDamageMultiplier.copy(goldDamageMultiplier);
            this.goldBonusString = NumberFormatter.formatBigNum(goldDamageMultiplier);
            this.body.innerHTML = this.goldBonusString;
        }

        super.updateViewContents();
    }

    /**
     * @override
     * @returns {string}
     */
    getVisibileDisplayValue() {
        return 'inline-block'; // This is a span element.  Don't use display:block.
    }

}